import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: () => ({
    position: "relative",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    touchAction: "none",
  }),
  img: {
    width: "100%",
  },
}));

function DraggableCard(props) {
  const { name, imgSrc } = props.card;
  const classes = useStyles(props);
  return (
    <div className={`${classes.root} draggable`} data-card-name={name}>
      <img src={imgSrc} className={classes.img} alt="" />
    </div>
  );
}

export default DraggableCard;
